import { type FC, type ReactNode } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ProfileListItem_profile$key } from '@/__generated__/ProfileListItem_profile.graphql'
import {
  Box,
  PressableListItem,
  ProfileAvatar,
  type PressableListItemProps,
  type ProfileAvatarProps
} from '@/components'

export interface ProfileListItemProps extends Omit<PressableListItemProps, 'left' | 'title'> {
  avatarStyle?: ProfileAvatarProps['style']
  // Overlaid on the bottom-right of the avatar (e.g. a SparkBadge). Omit for a plain avatar.
  badge?: ReactNode
  profileRef: ProfileListItem_profile$key | null | undefined
}

export const ProfileListItem: FC<ProfileListItemProps> = ({
  accessibilityLabel,
  avatarStyle,
  badge,
  profileRef,
  ...props
}) => {
  const profileData = useFragment(
    graphql`
      fragment ProfileListItem_profile on Profile {
        name
        ...ProfileAvatar_profile
      }
    `,
    profileRef
  )
  const avatar = (
    <ProfileAvatar
      className='h-10 w-10'
      profileRef={profileData}
      style={avatarStyle}
    />
  )

  return (
    <PressableListItem
      accessibilityLabel={accessibilityLabel ?? profileData?.name}
      left={
        badge ? (
          <Box className='relative'>
            {avatar}
            <Box className='absolute -bottom-1 -right-1'>{badge}</Box>
          </Box>
        ) : (
          avatar
        )
      }
      title={profileData?.name}
      {...props}
    />
  )
}
